import App from './App.svelte';

const app = new App({
	target: document.body,
	hydrate: true,
	props: {
		// model_root: 'http://localhost:8888/projects/pagels_garten/',
		// application_root: '...',
		model_root: 'https://admin.pagels-garten.de/model/',
		application_root: 'https://admin.pagels-garten.de/',
	}
});

export default app;
